import Form from './Form.vue'
import List from './List.vue'
import Duplicates from './Duplicates.vue'
import View from './View.vue'
import Info from './_info.vue'
import Calendar from './_calendar.vue'
import Maintenance from './_maintenance.vue'
import History from './_history.vue'
import Notes from './_notes.vue'
import Photos from './_photos.vue'
import Devices from './_devices.vue'
import Akts from './_akts.vue'

const routes = [{
  path: '/object/create',
  component: Form,
  name: 'object/create'
}, {
  path: '/object/:objectId/edit',
  component: Form,
  name: 'object/edit'
}, {
  path: '/object/list/:type',
  component: List,
  name: 'object/list'
}, {
  path: '/object/duplicates',
  component: Duplicates,
  name: 'object/duplicates'
}, {
  path: '/object/:objectId',
  component: View,
  name: 'object/view',
  children: [{
    path: '/object/:objectId/info',
    component: Info,
    name: 'object/view/info',
  }, {
    path: 'calendar',
    component: Calendar,
    name: 'object/view/calendar',
  }, {
    path: 'maintenance',
    component: Maintenance,
    name: 'object/view/maintenance',
  }, {
    path: 'history',
    component: History,
    name: 'object/view/history',
  }, {
    path: 'notes',
    component: Notes,
    name: 'object/view/notes',
  }, {
    path: 'photos',
    component: Photos,
    name: 'object/view/photos',
  }, {
    path: 'akts',
    component: Akts,
    name: 'object/view/akts',
  }, {
    path: 'devices',
    component: Devices,
    name: 'object/view/devices',
  }]
}]

export default routes